import React, { useCallback } from 'react'
import { actionButtonsColumnProps, BsrsGrid, Column } from '@/components/BsrsGrid'
import { Button } from '@/components/button'
import { openDialog } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { useLocalization } from '@/hooks/localization'
import { useDispatch } from '@/hooks/dispatch'
import { WhiteBox } from '@/components/Layout'

export function OutputReportDefinitionPermissions ({ outputReportDefinitionPermissions, onChange, jobPositionAssignmentId }) {
  const { localize } = useLocalization()
  const handleAdd = useCallback(({ item }) => {
    onChange([...outputReportDefinitionPermissions, item])
  }, [outputReportDefinitionPermissions, onChange])

  const handleEdit = useCallback(({ item, dataIndex }) => {
    const index = dataIndex - 1
    const items = outputReportDefinitionPermissions.map((x, idx) => {
      if (idx === index) { return item }
      return x
    })
    onChange(items)
  }, [outputReportDefinitionPermissions, onChange])

  const [showDialog] = useDispatch([openDialog])
  const onAddClick = useCallback(() => showDialog({
    dialogType: dialogTypes.outputReportGroupDefinitionPermissions,
    outputReportGroupDefinition: { id: 0, jobPositionAssignmentId },
    onAction: handleAdd
  }), [handleAdd, showDialog, jobPositionAssignmentId])

  const actionProps = actionButtonsColumnProps([
    { icon: 'pencil',
      onClick: (item, dataIndex) => {
        showDialog({
          dialogType: dialogTypes.outputReportGroupDefinitionPermissions,
          outputReportGroupDefinition: item,
          dataIndex,
          onAction: handleEdit
        })
      }
    },
    {
      onDelete: (item, dataIndex) => {
        onChange(outputReportDefinitionPermissions.filter((x, idx) => idx !== dataIndex - 1))
      }
    }
  ])

  return (
    <WhiteBox
      header='Permissions.OutputReportGroupsDefinitionPermissions'
      buttons={<Button icon='plus' color='primary' className='btn-sm' onClick={onAddClick}>{localize('Common.Add')}</Button>}
      transparent headerClass='no-uppercase'>
      <BsrsGrid items={outputReportDefinitionPermissions} simpleView>
        <Column field='outputReportDefinition' title={localize('Permissions.OutputReportGroupDefinition')} cell={OutputReportGroupDefinitionCell} />
        <Column title={' '} {...actionProps} />
      </BsrsGrid>
    </WhiteBox>
  )
}

function OutputReportGroupDefinitionCell ({ dataItem }) {
  return <td>{dataItem.outputReportGroupDefinition.name}</td>
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/jobPositionPermissions/outputReportDefinitionPermissions.js